import Excel from "exceljs";
import saveAs from "file-saver";
import { formatValue } from "../helpers/format.helper";
import {getPtqrCellStyle, getColorFromStyle} from '../helpers/style.helper';

const HR_BLACK_HEADERS_STYLES = {
    style: {
        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
    },
    fill: {
        type: 'pattern',
        pattern:'solid',
        fgColor: {argb: '00000000'},
        bgColor: {argb: '00000000'}
    },
    font: {
        color: {argb: '00ffffff'},
        family: 2,
        size: 10,
        name: 'Arial',
        bold: true
    },
};

const STAFFING_DASHBOARD_HEADER = {
    style: {
        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
    },
    fill: {
        type: 'pattern',
        pattern:'solid',
        fgColor: {argb: '00dee2e6'},
        bgColor: {argb: '00dee2e6'}
    },
    font: {
        color: {argb: '00000000'},
        family: 2,
        size: 10,
        name: 'Arial',
        bold: true
    },
};

const ARIAL_10 = {
    color: {argb: '00000000'},
    family: 2,
    size: 10,
    name: 'Arial'
}

const ARIAL_10_BOLD_LEFT = {
    alignment: { vertical: 'middle', horizontal: 'left'},
    font: { bold:true, ... ARIAL_10 }
}

const ARIAL_10_BORDER = {
    alignment: { vertical: 'middle', horizontal: 'left'},
    font: { bold:true, ... ARIAL_10 },
    border: {top: {style: 'thin'}}
}

const ARIAL_10_CENTER = {
    alignment: { vertical: 'middle', horizontal: 'center'},
    font: ARIAL_10
}

const filterAttainmentHeader = (key, showExtraColumns = false) => {
    if (!showExtraColumns) {
        return key;
    }
    return key.replace(' SOLD', '').replace(' ATTAINMENT', '');
}

class ExportServiceClass {
    constructor() {
        this.token = '';
    }

    createBook(username) {
        const wb = new Excel.Workbook();
        wb.creator = 'Riverside KPI App';
        wb.lastModifiedBy = username;
        wb.created = new Date();

        return wb;
    }

    async downloadBook(workbook, filename) {
        await workbook.xlsx.writeBuffer().then(function(buffer) {
            saveAs(
                new Blob([buffer], { type: "application/octet-stream" }),
                filename + '.xlsx'
            );
        });
    }

    async downloadKpi(sections, username, filename, isMonthly, headers) {
        let pages = [filename];
        const workbook = this.createBook(username);
        if (isMonthly) {
            pages = ['Actual vs Budget', 'Actual vs Prior Year'];
            if (!ENVIRONMENT.IS_OPERATIONS_KPIS) pages.push('Last 12 Months');
            pages.push('Quarterly');
        }

        pages.map((title, pageNumber) => {
            const sheet = workbook.addWorksheet(title);
            sheet.views = [{ state: 'frozen', xSplit: 3, ySplit: 1, topLeftCell: 'D2'}];

            if(!isMonthly){
                sheet.getRow(1).getCell(7).value = "Week Ending";
                sheet.getRow(1).getCell(7).style = {
                    font: {color: {argb: '00FFFFFF'}, family: 2, name: 'Arial', bold: true, size: 20 },
                    alignment: {vertical: 'middle', horizontal: 'left'},
                }
            }

            sheet.getRow(1).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '00FFFFFF'},
                bgColor: {argb: '00FFFFFF'}
            };

            sheet.getRow(1).font = {
                color: {argb: '00000000'},
                family: 2,
                name: 'Arial',
                bold: true
            };

            let kpis = [];
            let quarterly = [];
            let last12MonthsHeaders = [];
            // Dates columns
            headers.dates.map(id => {
                let data = {
                    header: id.toUpperCase(),
                    key: id,
                    style: {
                        alignment: { vertical: 'middle', horizontal: 'center' } },
                    width: 14
                };
                kpis.push(data);
            });
            if (isMonthly) {
                headers.quarterly.map(id => {
                    let data = {
                        header: id.toUpperCase(),
                        key: id,
                        style: {
                            alignment: { vertical: 'middle', horizontal: 'center' } },
                        width: 14
                    };
                    quarterly.push(data);
                });
                headers.last_12_months.map(id => {
                    let data = {
                        header: id,
                        key: id,
                        style: {
                            alignment: { vertical: 'middle', horizontal: 'center' } },
                        width: 14
                    };
                    last12MonthsHeaders.push(data);
                });
            }

            var headerColumns  = [
                { header: 'TITLE', key: 'title', width: 35,
                    style: {
                        alignment: { vertical: 'middle', horizontal: 'left', wrapText: true, indent: 1 },
                        font: { family: 2, name: 'Arial', bold: true },
                        fill: {
                            type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                            bgColor: {argb: '00f2f2f2'}
                        }
                    }
                },
                { header: 'TAXONOMY & DEF.', key: 'taxonomy', width: 35,
                    style: {
                        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
                        font: { family: 2, name: 'Arial', color: { argb: '000000ff' } },
                        fill: {
                            type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                            bgColor: {argb: '00d2e6ff'}
                        }
                    }
                },
                { header: 'TYPE', key: 'type', width: 12,
                    style: {
                        alignment: {vertical: 'middle', horizontal: 'center'},
                        font: { family: 2, name: 'Arial', size: 8 },
                        fill: {
                            type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                            bgColor: {argb: '00f2f2f2'}
                        }
                    }
                },
                ... (pageNumber < 2)? kpis : pageNumber === 2 ? last12MonthsHeaders : quarterly,
                { header: 'COMMENTS.', key: 'comments', width: 50, outlineLevel: 1,
                    style: {
                        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
                        font: { family: 2, name: 'Arial', color: { argb: '000000ff' } },
                        fill: {
                            type: 'pattern', pattern: 'solid', fgColor: {argb: '00000000'},
                            bgColor: {argb: '00000000'}
                        }
                    }
                }
            ];

            for (let columnIndex = 0; columnIndex < headerColumns.length; columnIndex++) {
                var column = headerColumns[columnIndex];
                sheet.getRow(2).getCell(columnIndex+1).value = column.header;
                sheet.getRow(2).getCell(columnIndex+1).style = column.style;
                sheet.getRow(2).getCell(columnIndex+1).fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor: {argb: '001f53a1'},
                    bgColor: {argb: '001f53a1'}
                };

                sheet.getRow(2).getCell(columnIndex+1).font = {
                    color: {argb: '00FFFFFF'},
                    family: 2,
                    name: 'Arial',
                    bold: true
                };
                sheet.columns[columnIndex].key = column.key;
                sheet.columns[columnIndex].width = column.width;
                sheet.columns[columnIndex].style.alignment = column.style.alignment;
            }

            sheet.font = {
                family: 2,
                name: 'Arial',
                size: 10
            };

            sections.map((section, section_id) => {
                let row = sheet.addRow({title: section.title});
                row.fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor: {argb: '00FFFFFF'},
                    bgColor: {argb: '00FFFFFF'}
                };

                row.font = {
                    color: {argb: '00000000'},
                    family: 2,
                    name: 'Arial',
                    bold: true,
                    size: 10
                };

                for(let i = 1; i <= headerColumns.length; i++){
                    row.getCell(i). fill = { type: 'pattern', pattern:'solid', fgColor: {argb: '00404040'}, bgColor: {argb: '00404040'} };
                    row.getCell(i).font = { color: {argb: '00f8f9fa'}, family: 2, name: 'Arial', bold: true };
                }

                if (section.kpis) {
                    section.kpis.map((kpi, kpi_id) => {
                        //Fill cells with data
                        if (kpi.kpiData) {
                            let rowDataActual = {title: kpi.title, taxonomy: kpi.taxonomy, type: 'ACTUAL', comments: kpi.comments};
                            let rowDataBudget = {title: '', taxonomy: '', type: pageNumber  != 1 ? 'BUDGET': 'PRIOR YEAR', comments: kpi.comments};
                            let rowDataPriorYear = {title: '', taxonomy: '', type: 'PRIOR YEAR', comments: kpi.comments}; //Used only when it's monthly quarterly report

                            Object.keys(kpi.kpiData).map(cell => {
                                const IS_YTD = cell === 'ytd';
                                let kpiData;

                                if (IS_YTD) {
                                    if (pageNumber < 2) {
                                        kpiData = kpi.kpiData[cell].ytd_actual_vs_budget;
                                        kpiData.prior = kpi.kpiData[cell].ytd_py;
                                    } else {
                                        kpiData = kpi.kpiData[cell].ytd_monthly_quarterly;
                                        kpiData.prior = kpiData.py;
                                    }
                                } else {
                                    kpiData = kpi.kpiData[cell];
                                }

                                if (pageNumber < 2 && headers.dates.includes(cell)) {
                                    let kpiValue = pageNumber == 0? kpiData.budget: kpiData.prior;
                                    if (kpi.format == 2) {
                                        rowDataActual[cell] = parseFloat(kpiData.actual * 1) / 100;
                                        if (kpi.show_budget) {
                                            rowDataBudget[cell] = parseFloat(kpiValue * 1) / 100;
                                        }
                                    } else {
                                        rowDataActual[cell] = kpiData.actual * 1;
                                        if (kpi.show_budget) {
                                            rowDataBudget[cell] = kpiValue * 1;
                                        }
                                    }
                                } else if ( pageNumber >= 2) {
                                    if ((pageNumber === 2 && !headers.last_12_months.includes(cell)) || (pageNumber === 3 && !headers.quarterly.includes(cell))) return;
                                    if (kpi.format === 2) {
                                        rowDataActual[cell] = parseFloat(kpiData.actual || 0 * 1) / 100;
                                        if (kpi.show_budget) {
                                            rowDataBudget[cell] = parseFloat(kpiData.budget || 0 * 1) / 100;
                                        }
                                        rowDataPriorYear[cell] = parseFloat(kpiData.prior || 0 * 1) / 100;
                                    } else {
                                        rowDataActual[cell] = kpiData.actual || 0 * 1;
                                        if (kpi.show_budget) {
                                            rowDataBudget[cell] = kpiData.budget || 0 * 1;
                                        }
                                        rowDataPriorYear[cell] = kpiData.prior || 0 * 1;
                                    }
                                }

                            });

                            let rowActual = sheet.addRow(rowDataActual);
                            let rowBudget = null;
                            if (kpi.show_budget) {
                                rowBudget = sheet.addRow(rowDataBudget);
                            }
                            if (pageNumber >= 2) {
                                var rowPriorYear = sheet.addRow(rowDataPriorYear);
                                rowPriorYear.getCell(3).style = { alignment: {vertical: 'middle', horizontal: 'center'}, font: { family: 2, name: 'Arial', size: 8, italic: true }, fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'}, bgColor: {argb: '00f2f2f2' } } };
                            }
                            //Manually apply colors to fixed columns due it's taking columns color.
                            //Title
                            rowActual.getCell(1).style = { alignment: { indent: 2, vertical: 'middle', horizontal: 'left', wrapText: true }, font: { family: 2, name: 'Arial', size: 10, bold: true }, fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'}, bgColor: {argb: '00f2f2f2' } } };
                            //Taxonomy
                            rowActual.getCell(2).style = { alignment: { indent: 2, vertical: 'middle', horizontal: 'left', wrapText: true }, font: { family: 2, name: 'Arial', size: 10, color: { argb: '000b52ff' } }, fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'}, bgColor: {argb: '00d2e6ff' } } };
                            //Type
                            rowActual.getCell(3).style = { alignment: { vertical: 'middle', horizontal: 'center'}, font: { family: 2, name: 'Arial', size: 8, italic: true }, fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'}, bgColor: {argb: '00f2f2f2' } } };

                            if (kpi.show_budget && rowBudget) {
                                rowBudget.getCell(3).style = { alignment: { vertical: 'middle', horizontal: 'center'}, font: { family: 2, name: 'Arial', size: 8, italic: true }, fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'}, bgColor: {argb: '00f2f2f2' } } };

                                //Merge title and taxonomy columns (vertically each one)
                                if (pageNumber < 2) {
                                    sheet.mergeCells(rowActual.getCell(1).address+':'+rowBudget.getCell(1).address);
                                    sheet.mergeCells(rowActual.getCell(2).address+':'+rowBudget.getCell(2).address);
                                }
                            }

                            if (pageNumber >= 2) {
                                sheet.mergeCells(rowActual.getCell(1).address+':'+rowPriorYear.getCell(1).address);
                                sheet.mergeCells(rowActual.getCell(2).address+':'+rowPriorYear.getCell(2).address);
                            }

                            var index = 4;
                            Object.keys(kpi.kpiData).forEach(element => {
                                const IS_YTD = element === 'ytd';
                                // Last 12 months will be loaded in a different function
                                if (element === 'last_12_months') return;
                                if (IS_YTD && pageNumber === 2) return;

                                let style;

                                if (IS_YTD) {
                                    if (pageNumber < 2) {
                                        style = kpi.kpiData[element].ytd_actual_vs_budget ? kpi.kpiData[element].ytd_actual_vs_budget.style : null;
                                    } else {
                                        style = kpi.kpiData[element].ytd_monthly_quarterly ? kpi.kpiData[element].ytd_monthly_quarterly.style : null;
                                    }
                                } else {
                                    style = kpi.kpiData[element].style;
                                }

                                let budgetStyle = pageNumber != 1 && kpi.kpiData[element].budgetStyle ? kpi.kpiData[element].budgetStyle : { text: "000000", background: "FFFFFF" };
                                if( pageNumber === 0 && headers.dates.includes(element)) {
                                    rowActual.getCell(index).font = {
                                        family: 2,
                                        name: 'Arial',
                                        size: 10,
                                        color: {argb: "00" + style.text}
                                    };

                                    rowActual.getCell(index).fill = {
                                        type: 'pattern',
                                        pattern:'solid',
                                        fgColor: {argb: "00"+style.background},
                                        bgColor: {argb: "00"+style.background}
                                    }

                                    if (kpi.show_budget && rowBudget) {
                                        rowBudget.getCell(index).font = {
                                            family: 2,
                                            name: 'Arial',
                                            size: 10,
                                            color: {argb: "00" + budgetStyle.text}
                                        };

                                        rowBudget.getCell(index).fill = {
                                            type: 'pattern',
                                            pattern:'solid',
                                            size: 10,
                                            fgColor: {argb: "00" + budgetStyle.background},
                                            bgColor: {argb: "00" + budgetStyle.background}
                                        }
                                    }
                                } else if ( pageNumber === 3 && headers.quarterly.includes(element)) {
                                    let columnsBefore = IS_YTD ? 0 : 12;
                                    rowActual.getCell(index-columnsBefore).font = {
                                        family: 2,
                                        name: 'Arial',
                                        size: 10,
                                        color: {argb: "00" + style.text}
                                    };

                                    rowActual.getCell(index-columnsBefore).fill = {
                                        type: 'pattern',
                                        pattern:'solid',
                                        fgColor: {argb: "00"+style.background},
                                        bgColor: {argb: "00"+style.background}
                                    }

                                    if (kpi.show_budget && rowBudget) {
                                        rowBudget.getCell(index-columnsBefore).font = {
                                            family: 2,
                                            name: 'Arial',
                                            size: 10,
                                            color: {argb: "00" + budgetStyle.text}
                                        };

                                        rowBudget.getCell(index-columnsBefore).fill = {
                                            type: 'pattern',
                                            pattern:'solid',
                                            fgColor: {argb: "00" + budgetStyle.background},
                                            bgColor: {argb: "00" + budgetStyle.background}
                                        }
                                    }

                                    rowPriorYear.getCell(index-columnsBefore).font = {
                                        family: 2,
                                        name: 'Arial',
                                        size: 10,
                                        color: {argb: "00000000"}
                                    };

                                    rowPriorYear.getCell(index-columnsBefore).fill = {
                                        type: 'pattern',
                                        pattern:'solid',
                                        fgColor: {argb: "00FFFFFF"},
                                        bgColor: {argb: "00FFFFFF"}
                                    }
                                }else {
                                    rowActual.getCell(index).font = {
                                        family: 2,
                                        name: 'Arial',
                                        color: {argb: "00000000"},
                                        size: 10
                                    };
                                    rowActual.getCell(index).fill = {
                                        type: 'pattern',
                                        pattern:'solid',
                                        fgColor: {argb: "00FFFFFF"},
                                        bgColor: {argb: "00FFFFFF"}
                                    }

                                    if (kpi.show_budget && rowBudget) {
                                        rowBudget.getCell(index).font = {
                                            family: 2,
                                            name: 'Arial',
                                            size: 10,
                                            color: {argb: "00000000"}
                                        };
                                        rowBudget.getCell(index).fill = {
                                            type: 'pattern',
                                            pattern:'solid',
                                            size: 10,
                                            fgColor: {argb: "00FFFFFF"},
                                            bgColor: {argb: "00FFFFFF"}
                                        }
                                    }

                                    if (pageNumber === 2) {
                                        rowPriorYear.getCell(index).font = {
                                            family: 2,
                                            name: 'Arial',
                                            size: 10,
                                            color: {argb: "00000000"}
                                        };

                                        rowPriorYear.getCell(index).fill = {
                                            type: 'pattern',
                                            pattern:'solid',
                                            fgColor: {argb: "00FFFFFF"},
                                            bgColor: {argb: "00FFFFFF"}
                                        }
                                    }
                                }

                                index++;
                            });

                            if (pageNumber === 2) {
                                rowPriorYear.border = {
                                    bottom: {style: 'thin', color: {argb: '00cccccc'}}
                                };
                            } else if (kpi.show_budget && rowBudget) {
                                rowBudget.border = {
                                    bottom: {style: 'thin', color: {argb: '00cccccc'}}
                                };
                            } else if (!kpi.show_budget && !rowPriorYear) {
                                rowActual.border = {
                                    bottom: {style: 'thin', color: {argb: '00cccccc'}}
                                };
                            }

                            let numFmt = '';

                            switch (kpi.format) {
                                case 1:
                                    numFmt = '"$"#,##0;[Red]\-"$"#,##0';
                                    break;
                                case 2:
                                    numFmt = '#,##0.0%';
                                    break;
                                case 0:
                                case 3:
                                    numFmt = '#,##0.0';
                                    break;
                                case 4:
                                    numFmt = '#,##0.0x';
                                    break;
                                case 5:
                                    numFmt = '#,##0.0" bps"';
                                    break;
                                default:
                                    break;
                            }
                            rowActual.numFmt = numFmt;
                            if (kpi.show_budget && rowBudget) {
                                rowBudget.numFmt = numFmt;
                            }
                            if (rowPriorYear) rowPriorYear.numFmt = numFmt;
                        }
                    });
                }
            });
        });

        await this.downloadBook(workbook, filename);
    }

    async downloadSDR(sections, username, filename, headers) {
        const workbook = this.createBook(username);
        const sheet = workbook.addWorksheet(filename);
        sheet.views = [{ state: 'frozen', xSplit: 2, ySplit: 1, topLeftCell: 'C2'}];

        sheet.getRow(0).fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor: {argb: '00FFFFFF'},
            bgColor: {argb: '00FFFFFF'}
        };

        sheet.getRow(0).font = {
            color: {argb: '00000000'},
            family: 2,
            name: 'Arial',
            bold: true
        };

        let kpis = [];
        // Dates columns
        headers.map(id => {
            let data = {
                header: id.toUpperCase(),
                key: id,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'center' } },
                width: 14
            };
            kpis.push(data);
        });

        var headerColumns  = [
            { header: 'TITLE', key: 'title', width: 40,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'left', wrapText: true, indent: 1 },
                    font: { family: 2, name: 'Arial', bold: true },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                        bgColor: {argb: '00f2f2f2'}
                    }
                }
            },
            { header: 'TAXONOMY & DEF.', key: 'taxonomy', width: 40,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
                    font: { family: 2, name: 'Arial', color: { argb: '000000ff' } },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            ... kpis,
            { header: 'COMMENTS.', key: 'comments', width: 50, outlineLevel: 1,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
                    font: { family: 2, name: 'Arial', color: { argb: '000000ff' } },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00000000'},
                        bgColor: {argb: '00000000'}
                    }
                }
            }

        ];

        for (let columnIndex = 0; columnIndex < headerColumns.length; columnIndex++) {
            var column = headerColumns[columnIndex];
            sheet.getRow(1).getCell(columnIndex+1).value = column.header;
            sheet.getRow(1).getCell(columnIndex+1).style = column.style;
            sheet.getRow(1).getCell(columnIndex+1).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '001f53a1'},
                bgColor: {argb: '001f53a1'}
            };

            sheet.getRow(1).getCell(columnIndex+1).font = {
                color: {argb: '00FFFFFF'},
                family: 2,
                name: 'Arial',
                bold: true
            };
            sheet.columns[columnIndex].key = column.key;
            sheet.columns[columnIndex].width = column.width;
            sheet.columns[columnIndex].style.alignment = column.style.alignment;
        }

        sheet.font = {
            family: 2,
            name: 'Arial',
            size: 10
        };

        sections.map((section, section_id) => {
            let row = sheet.addRow({title: section.title});

            row.fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '00FFFFFF'},
                bgColor: {argb: '00FFFFFF'}
            };

            row.font = {
                color: {argb: '00000000'},
                family: 2,
                name: 'Arial',
                bold: true,
                size: 10
            };

            for(let i = 1; i <= headerColumns.length; i++){
                row.getCell(i). fill = { type: 'pattern', pattern:'solid', fgColor: {argb: '00404040'}, bgColor: {argb: '00404040'} };
                row.getCell(i).font = { color: {argb: '00f8f9fa'}, family: 2, name: 'Arial', bold: true };
            }

            if (section.kpis) {
                section.kpis.map((kpi) => {
                    // Fill cells with data
                    if (kpi.kpiData) {
                        let rowDataActual = {title: kpi.title, taxonomy: kpi.taxonomy, comments: kpi.comments};
                        Object.keys(kpi.kpiData).map(cell => {
                            if (kpi.format == 2) {
                                rowDataActual[cell] = parseFloat(kpi.kpiData[cell].actual * 1) / 100;
                            } else {
                                rowDataActual[cell] = kpi.kpiData[cell].actual * 1;
                            }
                        });
                        let rowActual = sheet.addRow(rowDataActual);
                        // Manually apply colors to fixed columns due it's taking columns color.
                        // Title
                        rowActual.getCell(1).style = {
                            alignment: { indent: 2, vertical: 'middle', horizontal: 'left', wrapText: true },
                            font: { family: 2, name: 'Arial', size: 10, bold: true },
                            fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'}, bgColor: {argb: '00f2f2f2' } }
                        };
                        // Taxonomy
                        rowActual.getCell(2).style = {
                            alignment: { indent: 2, vertical: 'middle', horizontal: 'left', wrapText: true },
                            font: { family: 2, name: 'Arial', size: 10, color: { argb: '000b52ff' } },
                            fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'}, bgColor: {argb: '00d2e6ff' } }
                        };

                        var index = 3;
                        Object.keys(kpi.kpiData).forEach(element => {
                            // Add style to cells
                            let style = (kpi.kpiData[element].style) ? kpi.kpiData[element].style : {text: null, background: null};
                            rowActual.getCell(index).font = {
                                family: 2,
                                name: 'Arial',
                                size: 10,
                                color: {argb: "00" + (style.text || '000000')}
                            };

                            rowActual.getCell(index).fill = {
                                type: 'pattern',
                                pattern:'solid',
                                fgColor: {argb: "00" + (style.background || 'FFFFFF')},
                                bgColor: {argb: "00" + (style.background || 'FFFFFF')}
                            }
                            index++;
                        });
                        rowActual.height = 40;
                        switch(kpi.format) {
                            case 1:
                                rowActual.numFmt = '"$"#,##0;[Red]\-"$"#,##0';
                                break;
                            case 2:
                                rowActual.numFmt = '#,##0.0%';
                                break;
                            case 0:
                            case 3:
                                rowActual.numFmt = '#,##0.0';
                                break;
                            case 4:
                                rowActual.numFmt = '#,##0.0x';
                                break;
                            case 5:
                                rowActual.numFmt = '#,##0.0" bps"';
                                break;
                            default:
                                break;
                        }

                        // set collapse rows
                        if (section.sdr_collapse && kpi.sdr_formula === null) rowActual.outlineLevel = 1;
                    }
                });
            }
        });

        await this.downloadBook(workbook, filename);
    }

    async downloadTeams(teams, username, filename, rollingMonths, showExtraAttainment = false) {
        const workbook = this.createBook(username);

        const sheet = workbook.addWorksheet(filename);
        sheet.views = [{ state: 'frozen', xSplit: 3, ySplit: 3, topLeftCell: 'D4'}];

        const extraColumns = showExtraAttainment ? 7 : 1;

        if (showExtraAttainment) {
            const attainmentStartCol = 10;
            const soldStartCol = 14;

            sheet.getRow(2).getCell(attainmentStartCol).value = "% ATTAINMENT";
            sheet.getRow(2).getCell(soldStartCol).value = "$ SOLD";

            const attainmentRange = sheet.getRow(2).getCell(attainmentStartCol).address + ':' +
                                   sheet.getRow(2).getCell(attainmentStartCol + 3).address;

            const soldRange = sheet.getRow(2).getCell(soldStartCol).address + ':' +
                             sheet.getRow(2).getCell(soldStartCol + 3).address;

            sheet.mergeCells(attainmentRange);
            sheet.mergeCells(soldRange);

            const headerStyle = {
                font: {color: {argb: '00FFFFFF'}, family: 2, name: 'Arial', bold: true, size: 11},
                alignment: {vertical: 'middle', horizontal: 'center'},
                font: {color: {argb: '00000000'}, family: 2, name: 'Arial', bold: true, size: 10 }
            };

            sheet.getRow(2).getCell(attainmentStartCol).style = headerStyle;
            sheet.getRow(2).getCell(soldStartCol).style = headerStyle;

            sheet.getRow(1).height = 25;
        }

        // Merges
        const titleCellsToMerge = [
            sheet.getRow(2).getCell(13 + extraColumns).address + ':' + sheet.getRow(2).getCell(24 + extraColumns).address,
            sheet.getRow(2).getCell(26 + extraColumns).address + ':' + sheet.getRow(2).getCell(29 + extraColumns).address,
            sheet.getRow(2).getCell(31 + extraColumns).address + ':' + sheet.getRow(2).getCell(42 + extraColumns).address,
            sheet.getRow(2).getCell(44 + extraColumns).address + ':' + sheet.getRow(2).getCell(55 + extraColumns).address,
            sheet.getRow(2).getCell(57 + extraColumns).address + ':' + sheet.getRow(2).getCell(68 + extraColumns + rollingMonths).address,
            sheet.getRow(2).getCell(70 + extraColumns + rollingMonths).address + ':' + sheet.getRow(2).getCell(81 + extraColumns + rollingMonths).address
        ];

        titleCellsToMerge.forEach(range => sheet.mergeCells(range));

        const titles = [
            { "title": "SALES PERFORMANCE REPORT", "row": 1, "column": 1 },
            { "title": "YEAR", "row": 2, "column": 1 },
            { "title": filename.split("-")[1], "row": 1, "column": 2 },
            { "title": filename.split("-")[2], "row": 2, "column": 2 },
            { "title": "EMPLOYEE ATTAINMENT", "row": 2, "column": 13 + extraColumns },
            { "title": "QUARTERLY ATTAINMENT", "row": 2, "column": 26 + extraColumns },
            { 'title': 'PIPELINE TO QUOTA RATIO', 'row': 2, 'column': 31 + extraColumns },
            { "title": "EMPLOYEE PERFORMANCE", "row": 2, "column": 44 + extraColumns},
            { "title": `EMPLOYEE QUOTA (ROLLING ${rollingMonths} MONTHS)`, "row": 2, "column": 57 + extraColumns},
            { 'title': 'ROLLING GROSS PIPELINE', 'row': 2, 'column': 70 + extraColumns + rollingMonths }
        ];

        titles.forEach(title => {
            var horizontal = (title.column === 1 || title.column === 2)? 'left' : 'center';
            sheet.getRow(title.row).getCell(title.column).value = title.title;
            sheet.getRow(title.row).getCell(title.column).style = {
                font: {color: {argb: '00000000'}, family: 2, name: 'Arial', bold: true, size: 10 },
                alignment: {vertical: 'middle', horizontal: horizontal},
            }
        });

        let employeeCols = [];
        var generalWidth = 18;

        let employeesExample = teams.filter(section => section.employees && section.employees.length);

        if (!employeesExample.length) {
            alert('Not enough data to export.');
            return;
        }

        const employeeExampleData = employeesExample[0].employees[0].employeeData;

        let filteredAttainmentKeys = Object.keys(employeeExampleData.attainment);

        if (!showExtraAttainment) {
            filteredAttainmentKeys = filteredAttainmentKeys.filter(key =>
                key === 'rank' || (!key.includes('L3M_') &&
                 !key.includes('L1M_') && !key.includes('YTD_'))
            );
        }

        Object.keys(employeeExampleData).map(report => {
            const keysToProcess = report === 'attainment' ? filteredAttainmentKeys : Object.keys(employeeExampleData[report]);

            keysToProcess.map(id => {
                generalWidth = (id == 'Last_12_mo') ? 17 : (id == 'rank') ? 8 : 14;

                employeeCols.push({
                    header: id.replace(/_/g," ").toUpperCase(),
                    key: report + '-' + id,
                    style: {
                        alignment: { vertical: 'middle', wrapText: true, horizontal: 'center' } },
                    width: generalWidth
                });
            });

            if (report === 'attainment') {
                employeeCols.push({ header: 'COMMENTARY', key: 'notes', width: 25,
                    style: {
                        alignment: { vertical: 'middle', horizontal: 'left' },
                        font: { family: 2, name: 'Arial', size: 10 },
                        fill: {
                            type: 'pattern', pattern: 'solid', fgColor: {argb: '00FFFFFF'},
                            bgColor: {argb: '00FFFFFF'}
                        }
                    }
                });
            }

            employeeCols.push({
                header: '',
                key: report + '-space',
                style: {
                    alignment: {vertical: 'middle', horizontal: 'center'},
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00FFFFFF'},
                        bgColor: {argb: '00FFFFFF'}
                    }
                },
                width: 1
            });
        });

        var headerColumns = [
            { header: 'NAME', key: 'name', width: 33,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'left' },
                    font: { family: 2, name: 'Arial', bold: true, size: 10 },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                        bgColor: {argb: '00f2f2f2'}
                    }
                }
            },
            { header: 'POSITION', key: 'position', width: 40,
                style: {
                    alignment: { vertical: 'middle',  horizontal: 'center' },
                    font: { family: 2, name: 'Arial', color: { argb: '000000ff' }, size: 10 },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'DATE\nSTARTED', key: 'date_started', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial',  size: 10, color: { argb: '000000ff' } },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'DATE\nENDED', key: 'date_ended', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'TENURE\n(MONTHS)', key: 'tenure', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'ONBOARD MONTH', key: 'onboard_month', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'ONBOARD PERF', key: 'onboard_perf', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'RAMPED MONTH', key: 'ramped_month', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            ...employeeCols
        ];

        var columnsKey = [];

        for (let columnIndex = 0; columnIndex < headerColumns.length; columnIndex++) {
            var column = headerColumns[columnIndex];
            columnsKey.push({"key":column.key, "width": column.width});
            sheet.getRow(3).getCell(columnIndex+1).value = filterAttainmentHeader(column.header, showExtraAttainment);
            sheet.getRow(3).getCell(columnIndex+1).style = column.style;
            sheet.getRow(3).getCell(columnIndex+1).width = column.width;
            sheet.getRow(3).getCell(columnIndex+1).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '001f53a1'},
                bgColor: {argb: '001f53a1'}
            };

            sheet.getRow(3).getCell(columnIndex+1).font = {
                color: {argb: '00f8f9fa'},
                family: 2,
                name: 'Arial',
                bold: true
            };
        }

        sheet.columns = columnsKey;
        sheet.font = {
            family: 2,
            name: 'Arial',
            size: 10
        };

        //Set spaces white
        const spaceColumns = titles.slice(4).map(title => (title.column - 1));

        spaceColumns.forEach((columnIndex, index) => {
            sheet.getRow(3).getCell(columnIndex).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '00FFFFFF'},
                bgColor: {argb: '00FFFFFF'}
            }
        });

        sheet.getRow(3).height = 30;

        teams.map((team) => {
            let row = sheet.addRow({name: team.title});

            row.font = {
                color: {argb: '00f8f9fa'},
                family: 2,
                name: 'Arial',
                size: 10,
                bold: true
            };

            const lastTeamColumn = spaceColumns[spaceColumns.length - 1] + 14;
            for (let teamTitleColumn = 1; teamTitleColumn <= lastTeamColumn; teamTitleColumn++) {
                const fillParams = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor: {argb: '00000000'},
                    bgColor: {argb: '00000000'},
                };

                if (spaceColumns.includes(teamTitleColumn) ) {
                    fillParams.fgColor.argb = '00FFFFFF';
                    fillParams.bgColor.argb = '00FFFFFF';
                }

                row.getCell(teamTitleColumn).fill = fillParams;
            }

            if (team.employees) {
                team.employees.map((employee) => {
                    if (employee.employeeData) {
                        let rowData = {
                            "name": employee.name,
                            "position": employee.position,
                            "date_started": employee.start_date_formatted,
                            "date_ended": employee.end_date_formatted,
                            "tenure": employee.tenure,
                            "onboard_month": employee.onboard_month,
                            "onboard_perf": employee.onboard_perf,
                            "ramped_month": employee.ramped_month,
                            "notes": employee.notes || ''
                        };

                        Object.keys(employee.employeeData).map(report => {
                            // 3 jsons: attainment, performance and quota
                            let keysToProcess = Object.keys(employee.employeeData[report]);

                            if (report === 'attainment' && !showExtraAttainment) {
                                keysToProcess = keysToProcess.filter(id =>
                                    id === 'rank' || (!id.includes('L3M_') &&
                                     !id.includes('L1M_') && !id.includes('YTD_'))
                                );
                            }

                            keysToProcess.map(id => {
                                if(report == 'attainment' || report == 'attainment_list' || report == 'quarterly_attainment'){
                                    if(id != 'rank'){
                                        // Check if it's a Sold value
                                        if (id.includes('_Sold')) {
                                            // Don't divide by 100 for Sold values as they're not percentages
                                            rowData[report+'-'+id] = employee.employeeData[report][id].value;
                                        } else {
                                            // For attainment values (percentages)
                                            rowData[report+'-'+id] = employee.employeeData[report][id].value / 100;
                                        }
                                    } else {
                                        rowData[report+'-'+id] = employee.employeeData[report][id];
                                    }
                                } else if (['performance', 'quota', 'pipeline'].includes(report)){
                                    // Performance, quota and pipeline
                                    if (team.format == 2) {
                                        rowData[report+'-'+id] = employee.employeeData[report][id].value / 100;
                                    } else {
                                        rowData[report+'-'+id] = employee.employeeData[report][id].value;
                                    }
                                } else {
                                    rowData[report+'-'+id] = employee.employeeData[report][id].value;
                                }
                            });
                            rowData[report+'-space'] = '';
                        });

                        row = sheet.addRow(rowData);
                        row.font =  { family: 2, name: 'Arial', size: 10 };

                        for (let columnIndex = 1; columnIndex <= 9; columnIndex++) {
                            var bgColor, horizontalAlignment, bold, fontColor;
                            if(columnIndex == 1){
                                bgColor = '00f2f2f2', horizontalAlignment = 'left', bold = true, fontColor = '00000000';
                            } else {
                                bgColor = '00d2e6ff', horizontalAlignment = 'center', bold = false, fontColor = '000000ff';
                            }
                            row.getCell(columnIndex).style = {
                                alignment: { vertical: 'middle', horizontal: horizontalAlignment },
                                font: {...row.font, bold: bold, color: {argb: fontColor}},
                                fill: {
                                    type: 'pattern', pattern: 'solid', fgColor: {argb: bgColor},
                                    bgColor: {argb: bgColor}
                                }
                            }
                        }

                        var index = 9;
                        Object.keys(employee.employeeData).map(report => {
                            // Filter keys if needed
                            let keysToProcess = Object.keys(employee.employeeData[report]);

                            if (report === 'attainment' && !showExtraAttainment) {
                                keysToProcess = keysToProcess.filter(id =>
                                    id === 'rank'|| (!id.includes('L3M_') &&
                                     !id.includes('L1M_') && !id.includes('YTD_'))
                                );
                            }

                            keysToProcess.map(id => {
                                row.getCell(index).alignment = {
                                    vertical: 'middle',
                                    horizontal: 'center'
                                }

                                row.getCell(index).font = {
                                    family: 2,
                                    size: 10,
                                    name: 'Arial'
                                };
                                if(report == 'attainment' || report == 'attainment_list' || report == 'quarterly_attainment'){
                                    if(id != 'rank'){
                                        if (id.includes('_Sold')) {
                                            row.getCell(index).font = {
                                                color: {argb: '00000000'}, // Black text
                                                family: 2,
                                                size: 10,
                                                name: 'Arial'
                                            };
                                            row.getCell(index).fill = {
                                                type: 'pattern',
                                                pattern:'solid',
                                                fgColor: {argb: '00FFFFFF'}, // White background
                                                bgColor: {argb: '00FFFFFF'}
                                            }
                                            row.getCell(index).numFmt = '"$"#,##0;[Red]\-"$"#,##0';
                                        } else {
                                            row.getCell(index).font = {
                                                color: {argb: '00'+employee.employeeData[report][id].style.text },
                                                family: 2,
                                                size: 10,
                                                name: 'Arial'
                                            };
                                            row.getCell(index).fill = {
                                                type: 'pattern',
                                                pattern:'solid',
                                                fgColor: {argb: '00'+employee.employeeData[report][id].style.background },
                                                bgColor: {argb: '00'+employee.employeeData[report][id].style.background }
                                            }
                                            row.getCell(index).numFmt = '0.0%';
                                        }
                                    }
                                } else {
                                    //Performance and quota
                                    if(['ptqr', 'quota'].includes(report)){
                                        row.getCell(index).font = {
                                            color: {argb: '00'+employee.employeeData[report][id].style.text},
                                            family: 2,
                                            size: 10,
                                            name: 'Arial'
                                        };

                                        const ptqrCellStyle = getPtqrCellStyle(employee.employeeData[report][id].value,team.style);

                                        const backgroundColor = report === 'ptqr' ?
                                            getColorFromStyle(ptqrCellStyle) :
                                            '00'+employee.employeeData[report][id].style.background;

                                        row.getCell(index).fill = {
                                            type: 'pattern',
                                            pattern:'solid',
                                            fgColor: {
                                                argb: backgroundColor
                                            },
                                            bgColor: {
                                                argb: backgroundColor
                                            }
                                        }
                                    }
                                    //Set quota and performance format
                                    const formatType = report === 'ptqr' ? 4 : team.format;
                                    switch(formatType) {
                                        case 1:
                                            row.getCell(index).numFmt = '"$"#,##0;[Red]\-"$"#,##0';
                                            break;
                                        case 2:
                                            row.getCell(index).numFmt = '#,##0.0%';
                                            break;
                                        case 3:
                                            row.getCell(index).numFmt = '#,##0.0';
                                            break;
                                        case 4:
                                            row.getCell(index).numFmt = '#,##0.0x';
                                            break;
                                        case 5:
                                            row.getCell(index).numFmt = '#,##0.0" bps"';
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                index++;
                            });

                            if (report === 'attainment') index++; // Include an extra column for spacing
                            //Space between tables
                            index++;
                        });

                        row.border = {
                            bottom: {style: 'thin', color: {argb: '00cccccc'}}
                        };

                    }
                });
            }
            let emptyRow = sheet.addRow({name: "", position: "", date_started: "", date_ended: "", tenure: "", });
            emptyRow.fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '00FFFFFF'},
                bgColor: {argb: '00FFFFFF'}
            };
            emptyRow.commit();
        });

        await this.downloadBook(workbook, filename);
    }

    async downloadIndividualAllPortcos(employees, username, filename, rollingMonths, showExtraAttainment = false) {
        const workbook = this.createBook(username);

        const sheet = workbook.addWorksheet(filename);
        sheet.views = [{ state: 'frozen', xSplit: 3, ySplit: 3, topLeftCell: 'D4'}];

        const extraColumns = showExtraAttainment ? 7 : 1;

        if (showExtraAttainment) {
            const attainmentStartCol = 12;
            const soldStartCol = 16;

            sheet.getRow(2).getCell(attainmentStartCol).value = "% ATTAINMENT";
            sheet.getRow(2).getCell(soldStartCol).value = "$ SOLD";

            const attainmentRange = sheet.getRow(2).getCell(attainmentStartCol).address + ':' +
                                   sheet.getRow(2).getCell(attainmentStartCol + 3).address;

            const soldRange = sheet.getRow(2).getCell(soldStartCol).address + ':' +
                             sheet.getRow(2).getCell(soldStartCol + 3).address;

            sheet.mergeCells(attainmentRange);
            sheet.mergeCells(soldRange);

            const headerStyle = {
                font: {color: {argb: '00FFFFFF'}, family: 2, name: 'Arial', bold: true, size: 11},
                alignment: {vertical: 'middle', horizontal: 'center'},
                font: {color: {argb: '00000000'}, family: 2, name: 'Arial', bold: true, size: 10 }
            };

            sheet.getRow(2).getCell(attainmentStartCol).style = headerStyle;
            sheet.getRow(2).getCell(soldStartCol).style = headerStyle;

            sheet.getRow(1).height = 25;
        }

        // Merges
        const titleCellsToMerge = [
            sheet.getRow(2).getCell(15 + extraColumns).address + ':' + sheet.getRow(2).getCell(26 + extraColumns).address,
            sheet.getRow(2).getCell(28 + extraColumns).address + ':' + sheet.getRow(2).getCell(31 + extraColumns).address,
            sheet.getRow(2).getCell(33 + extraColumns).address + ':' + sheet.getRow(2).getCell(44 + extraColumns).address,
            sheet.getRow(2).getCell(46 + extraColumns).address + ':' + sheet.getRow(2).getCell(57 + extraColumns).address,
            sheet.getRow(2).getCell(59 + extraColumns).address + ':' + sheet.getRow(2).getCell(70 + extraColumns + rollingMonths).address,
            sheet.getRow(2).getCell(72 + extraColumns + rollingMonths).address + ':' + sheet.getRow(2).getCell(83 + extraColumns + rollingMonths).address
        ];

        titleCellsToMerge.forEach(range => sheet.mergeCells(range));

        const titles = [
            { "title": "SALES PERFORMANCE REPORT", "row": 1, "column": 1 },
            { "title": "YEAR", "row": 2, "column": 1 },
            { "title": filename.split("-")[1], "row": 1, "column": 2 },
            { "title": filename.split("-")[2], "row": 2, "column": 2 },
            { "title": "EMPLOYEE ATTAINMENT", "row": 2, "column": 15 + extraColumns },
            { "title": "QUARTERLY ATTAINMENT", "row": 2, "column": 28 + extraColumns },
            { 'title': 'PIPELINE TO QUOTA RATIO', 'row': 2, 'column': 33 + extraColumns },
            { "title": "EMPLOYEE PERFORMANCE", "row": 2, "column": 46 + extraColumns},
            { "title": `EMPLOYEE QUOTA (ROLLING ${rollingMonths} MONTHS)`, "row": 2, "column": 59 + extraColumns},
            { 'title': 'ROLLING GROSS PIPELINE', 'row': 2, 'column': 72 + extraColumns + rollingMonths }
        ];

        titles.forEach(title => {
            var horizontal = (title.column === 1 || title.column === 2)? 'left' : 'center';
            sheet.getRow(title.row).getCell(title.column).value = title.title;
            sheet.getRow(title.row).getCell(title.column).style = {
                font: {color: {argb: '00000000'}, family: 2, name: 'Arial', bold: true, size: 10 },
                alignment: {vertical: 'middle', horizontal: horizontal},
            }
        });

        let employeeCols = [];
        var generalWidth = 18;

        if (!employees.length) {
            alert('Not enough data to export.');
            return;
        }

        let employeeExampleData = employees[0].employeeData;

        Object.keys(employeeExampleData).map(report => {
            // Filter keys if needed
            let keysToProcess = Object.keys(employeeExampleData[report]);

            if (report === 'attainment' && !showExtraAttainment) {
                keysToProcess = keysToProcess.filter(id =>
                    id === 'rank'  || (!id.includes('L3M_') &&
                     !id.includes('L1M_') && !id.includes('YTD_'))
                );
            }

            keysToProcess.map(id => {
                generalWidth = (id == 'Last_12_mo') ? 17 : 14;

                employeeCols.push({
                    header: id.replace(/_/g," ").toUpperCase(),
                    key: report + '-' + id,
                    style: {
                        alignment: { vertical: 'middle', wrapText: true, horizontal: 'center' } },
                    width: generalWidth
                });
            });

            if (report === 'attainment') {
                employeeCols.push({ header: 'COMMENTARY', key: 'notes', width: 25,
                    style: {
                        alignment: { vertical: 'middle', horizontal: 'left' },
                        font: { family: 2, name: 'Arial', size: 10 },
                        fill: {
                            type: 'pattern', pattern: 'solid', fgColor: {argb: '00FFFFFF'},
                            bgColor: {argb: '00FFFFFF'}
                        }
                    }
                });
            }

            employeeCols.push({
                header: '',
                key: report + '-space',
                style: {
                    alignment: {vertical: 'middle', horizontal: 'center'},
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00FFFFFF'},
                        bgColor: {argb: '00FFFFFF'}
                    }
                },
                width: 1
            });
        });

        var headerColumns = [
            { header: 'COMPANY', key: 'company', width: 33,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'left' },
                    font: { family: 2, name: 'Arial', bold: true, size: 10 },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                        bgColor: {argb: '00f2f2f2'}
                    }
                }
            },
            { header: 'SECTION', key: 'section', width: 33,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'left' },
                    font: { family: 2, name: 'Arial', bold: true, size: 10 },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                        bgColor: {argb: '00f2f2f2'}
                    }
                }
            },
            { header: 'NAME', key: 'name', width: 33,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'left' },
                    font: { family: 2, name: 'Arial', bold: true, size: 10 },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                        bgColor: {argb: '00f2f2f2'}
                    }
                }
            },
            { header: 'POSITION', key: 'position', width: 40,
                style: {
                    alignment: { vertical: 'middle',  horizontal: 'center' },
                    font: { family: 2, name: 'Arial', color: { argb: '000000ff' }, size: 10 },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'DATE\nSTARTED', key: 'date_started', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial',  size: 10, color: { argb: '000000ff' } },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'DATE\nENDED', key: 'date_ended', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'TENURE\n(MONTHS)', key: 'tenure', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'ONBOARD MONTH', key: 'onboard_month', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'ONBOARD PERF', key: 'onboard_perf', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'RAMPED MONTH', key: 'ramped_month', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            ...employeeCols
        ];

        var columnsKey = [];

        for (let columnIndex = 0; columnIndex < headerColumns.length; columnIndex++) {
            var column = headerColumns[columnIndex];
            columnsKey.push({"key":column.key, "width": column.width});
            sheet.getRow(3).getCell(columnIndex+1).value = filterAttainmentHeader(column.header, showExtraAttainment);
            sheet.getRow(3).getCell(columnIndex+1).style = column.style;
            sheet.getRow(3).getCell(columnIndex+1).width = column.width;
            sheet.getRow(3).getCell(columnIndex+1).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '001f53a1'},
                bgColor: {argb: '001f53a1'}
            };

            sheet.getRow(3).getCell(columnIndex+1).font = {
                color: {argb: '00f8f9fa'},
                family: 2,
                name: 'Arial',
                bold: true
            };
        }

        sheet.columns = columnsKey;
        sheet.font = {
            family: 2,
            name: 'Arial',
            size: 10
        };

        //Set spaces white
        const spaceColumns = titles.slice(4).map(title => (title.column - 1));

        spaceColumns.forEach(columnIndex => {
            sheet.getRow(3).getCell(columnIndex).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '00FFFFFF'},
                bgColor: {argb: '00FFFFFF'}
            }
        });

        sheet.getRow(3).height = 30;

        employees.map((employee) => {
            if (employee.employeeData) {
                let rowData = {
                    "company": employee.company,
                    "section": employee.section,
                    "name": employee.name,
                    "position": employee.position,
                    "date_started": employee.start_date_formatted,
                    "date_ended": employee.end_date_formatted,
                    "tenure": employee.tenure,
                    "onboard_month": employee.onboard_month,
                    "onboard_perf": employee.onboard_perf,
                    "ramped_month": employee.ramped_month,
                    "notes": employee.notes || ''
                };

                Object.keys(employee.employeeData).map(report => {
                    // Tables
                    // Filter keys based on the showExtraAttainment flag
                    let keysToProcess = Object.keys(employee.employeeData[report]);

                    if (report === 'attainment' && !showExtraAttainment) {
                        keysToProcess = keysToProcess.filter(id =>
                            id === 'rank' || (!id.includes('L3M_') &&
                             !id.includes('L1M_') && !id.includes('YTD_'))
                        );
                    }

                    keysToProcess.map(id => {
                        if(report == 'attainment' || report == 'attainment_list' || report == 'quarterly_attainment'){
                            if(id != 'rank'){
                                if (id.includes('_Sold')) {
                                    rowData[report+'-'+id] = employee.employeeData[report][id].value;
                                } else {
                                    rowData[report+'-'+id] = employee.employeeData[report][id].value / 100;
                                }
                            } else {
                                rowData[report+'-'+id] = employee.employeeData[report][id];
                            }
                        } else if (['performance', 'quota', 'pipeline'].includes(report)){
                            if (employee.section_format == 2) {
                                rowData[report+'-'+id] = employee.employeeData[report][id].value / 100;
                            } else {
                                rowData[report+'-'+id] = employee.employeeData[report][id].value;
                            }
                        } else {
                            rowData[report+'-'+id] = employee.employeeData[report][id].value;
                        }
                    });
                    rowData[report+'-space'] = '';
                });

                let row = sheet.addRow(rowData);
                for (let columnIndex = 1; columnIndex <= 11; columnIndex++) {
                    var bgColor, horizontalAlignment, bold, fontColor;
                    if(columnIndex <= 3){
                        bgColor = '00f2f2f2', horizontalAlignment = 'left', bold = true, fontColor = '00000000';
                    } else {
                        bgColor = '00d2e6ff', horizontalAlignment = 'center', bold = false, fontColor = '000000ff';
                    }
                    row.getCell(columnIndex).style = {
                        alignment: { vertical: 'middle', horizontal: horizontalAlignment },
                        font: { family: 2, bold: bold, name: 'Arial', size: 10 , color : { argb: fontColor } },
                        fill: {
                            type: 'pattern', pattern: 'solid', fgColor: {argb: bgColor},
                            bgColor: {argb: bgColor}
                        }
                    }
                }

                var index = 11;
                Object.keys(employee.employeeData).map(report => {
                    // Filter keys if needed
                    let keysToProcess = Object.keys(employee.employeeData[report]);

                    if (report === 'attainment' && !showExtraAttainment) {
                        keysToProcess = keysToProcess.filter(id =>
                            id === 'rank' || (!id.includes('L3M_') &&
                             !id.includes('L1M_') && !id.includes('YTD_'))
                        );
                    }

                    keysToProcess.map(id => {
                        row.getCell(index).alignment = {
                            vertical: 'middle',
                            horizontal: 'center'
                        }

                        row.getCell(index).font = {
                            family: 2,
                            size: 10,
                            name: 'Arial'
                        };

                        if(report == 'attainment' || report == 'attainment_list' || report == 'quarterly_attainment'){
                            if(id != 'rank'){
                                // Check if it's a Sold value
                                if (id.includes('_Sold')) {
                                    // Sold values with standard style (no background, black text)
                                    row.getCell(index).font = {
                                        color: {argb: '00000000'}, // Black text
                                        family: 2,
                                        size: 10,
                                        name: 'Arial'
                                    };
                                    row.getCell(index).fill = {
                                        type: 'pattern',
                                        pattern:'solid',
                                        fgColor: {argb: '00FFFFFF'}, // White background
                                        bgColor: {argb: '00FFFFFF'}
                                    }
                                    // Format as currency
                                    row.getCell(index).numFmt = '"$"#,##0;[Red]\-"$"#,##0';
                                } else {
                                    // Attainment values with colored background
                                    row.getCell(index).font = {
                                        color: {argb: '00'+employee.employeeData[report][id].style.text },
                                        family: 2,
                                        size: 10,
                                        name: 'Arial'
                                    };
                                    row.getCell(index).fill = {
                                        type: 'pattern',
                                        pattern:'solid',
                                        fgColor: {argb: '00'+employee.employeeData[report][id].style.background },
                                        bgColor: {argb: '00'+employee.employeeData[report][id].style.background }
                                    }
                                    row.getCell(index).numFmt = '0.0%';
                                }
                            }
                        } else {
                            //Performance and quota
                            if(['ptqr', 'quota'].includes(report)){
                                row.getCell(index).font = {
                                    color: {argb: '00'+employee.employeeData[report][id].style.text},
                                    family: 2,
                                    size: 10,
                                    name: 'Arial'
                                };

                                const ptqrCellStyle = getPtqrCellStyle(employee.employeeData[report][id].value,employee.section_style);

                                const backgroundColor = report === 'ptqr' ?
                                    getColorFromStyle(ptqrCellStyle) :
                                    '00'+employee.employeeData[report][id].style.background;

                                row.getCell(index).fill = {
                                    type: 'pattern',
                                    pattern:'solid',
                                    fgColor: {
                                        argb: backgroundColor
                                    },
                                    bgColor: {
                                        argb: backgroundColor
                                    }
                                }
                            }
                            //Set quota and performance format
                            const formatType = report === 'ptqr' ? 4 : employee.section_format;
                            switch(formatType) {
                                case 1:
                                    row.getCell(index).numFmt = '"$"#,##0;[Red]\-"$"#,##0';
                                    break;
                                case 2:
                                    row.getCell(index).numFmt = '#,##0.0%';
                                    break;
                                case 3:
                                    row.getCell(index).numFmt = '#,##0.0';
                                    break;
                                case 4:
                                    row.getCell(index).numFmt = '#,##0.0x';
                                    break;
                                case 5:
                                    row.getCell(index).numFmt = '#,##0.0" bps"';
                                    break;
                                default:
                                    break;
                            }
                        }
                        index++;
                    });

                    if (report === 'attainment') index++; // Include an extra column for spacing
                    //Space between tables
                    index++;
                });

                row.border = {
                    bottom: {style: 'thin', color: {argb: '00cccccc'}}
                };
            }
        });

        let emptyRow = sheet.addRow({name: "", position: "", date_started: "", date_ended: "", tenure: "", });
        emptyRow.fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor: {argb: '00FFFFFF'},
            bgColor: {argb: '00FFFFFF'}
        };
        emptyRow.commit();

        await this.downloadBook(workbook, filename);
    }

    async downloadCommonHrReport(headers, items, filename, hrTabName, cellCountToFreeze) {
        const workbook = this.createBook();
        const sheet = workbook.addWorksheet(filename);

        const tableTitleCell = sheet.addRow([`${hrTabName.toUpperCase()} REPORT`]);

        tableTitleCell.font = {
            family: 2,
            name: 'Arial',
            size: 12,
            bold: true,
        };

        const headerRow = sheet.addRow(headers.map(h => h.title.toUpperCase()));
        headerRow.height = 30;

        headers.forEach((header, index) => {
            const headerCell = headerRow.getCell(index+1);
            headerCell.style = {
                alignment: { vertical: 'middle', horizontal: 'center' },
            };
            headerCell.style = HR_BLACK_HEADERS_STYLES.style;
            headerCell.fill = HR_BLACK_HEADERS_STYLES.fill;
            headerCell.font = HR_BLACK_HEADERS_STYLES.font;
        });

        for (const item of items) {
            const row = [];

            for (const header of headers) {
                row.push(item[header.key]);
            }
            const sheetRow = sheet.addRow(row);

            for (let i = 1; i <= headers.length; i++) {
                const cell = sheetRow.getCell(i);
                if(i <= 6){
                    cell.style = {alignment: { wrapText: true }};
                }

                cell.font = {
                    color: {argb: '00000000'},
                    family: 2,
                    name: 'Arial',
                    size: 10,
                    bold: false
                };
            }
        }

        sheet.columns = headers.map(h => ({width: h.exportWidth}));
        sheet.views = [
                {
                    state: 'frozen',
                    xSplit: cellCountToFreeze,
                    ySplit: 2,
                }
            ];

        await this.downloadBook(workbook, filename);
    }

    async downloadStaffingBudget(reportData, yearlyHeadCount, filename, year, isFacilitator) {
        const { staff: monthlyKeys } = reportData.headers;
        const { staff: staffItems } = reportData;

        const staffHeaders = [
            {
                name: 'EMPLOYEE NAME',
                key: 'employee_name',
                exportWidth: 20,
            },
            {
                name: 'JOB ROLE',
                key: 'job_role',
                exportWidth: 30,
            },
            {
                name: 'DEPARTMENT',
                key: 'department',
                exportWidth: 15,
            },
            ...monthlyKeys.map(key => ({name: key, key, exportWidth: 15, isMonth: true}))
        ];

        if (!isFacilitator) {
            staffHeaders.unshift({
                name: 'COMPANY',
                key: 'company',
                exportWidth: 40,
            });
        }

        const yearlyHeadCountMonth = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const yearlyHeadCountHeaders = ['BUDGET', '', '', '', ...yearlyHeadCountMonth.map((header) => `${header.toUpperCase()}/${year}`)];

        const workbook = this.createBook();
        const sheet = workbook.addWorksheet(filename);

        sheet
            .addRow(['STAFFING BUDGET REPORT'])
            .font = {
                family: 2,
                name: 'Arial',
                size: 12,
                bold: true,
            };

        if (isFacilitator) {
            const yearlyHeadersRow = sheet.addRow(yearlyHeadCountHeaders);

            for (let i = 1; i <= yearlyHeadCountHeaders.length; i++) {
                const headerCell = yearlyHeadersRow.getCell(i);

                headerCell.style = HR_BLACK_HEADERS_STYLES.style;
                headerCell.fill = HR_BLACK_HEADERS_STYLES.fill;
                headerCell.font = HR_BLACK_HEADERS_STYLES.font;
            }

            Object.keys(yearlyHeadCount).forEach(key => {
                const row = sheet.addRow([key, '', '', '', ...yearlyHeadCount[key]]);

                row.getCell(4).font = {bold: true};

                row.eachCell(c => c.style = {alignment: { horizontal: 'center' }});
            });

            // merge first table budget cells
            for (let i = 1; i < 5; i++) {
                sheet.mergeCells(i, 1, i, 4);

                if (i > 2) {
                    sheet.getRow(i).getCell(1).style = {alignment: { horizontal: 'center' }};
                }
            }

            sheet.addRow([]);
        }

        const staffHeadersRow = sheet.addRow(staffHeaders.map(header => header.name));

        for (let i = 1; i <= staffHeaders.length; i++) {
            const headerCell = staffHeadersRow.getCell(i);

            headerCell.style = HR_BLACK_HEADERS_STYLES.style;
            headerCell.fill = HR_BLACK_HEADERS_STYLES.fill;
            headerCell.font = HR_BLACK_HEADERS_STYLES.font;
        }

        for (const staff of staffItems) {
            const row = [];

            staffHeaders.forEach((header, index) => {
                const value = !staff[header.key] && index > 3 ? '0' : staff[header.key];

                row.push(value);
            });

            const staffRow = sheet.addRow(row);

            staffRow.eachCell((c, index) => {
                if (index > 4) {
                    c.style = {alignment: { horizontal: 'center' }};
                }else{
                    c.style = {alignment: { wrapText: true }};
                }
            });

            for (let i = 1; i <= staffHeaders.length; i++) {
                staffRow.getCell(i).font = {
                    color: {argb: '00000000'},
                    family: 2,
                    name: 'Arial',
                    size: 10,
                    bold: false
                };
            }
        }

        sheet.columns = staffHeaders.map((h) => ({width: h.exportWidth}));

        sheet.views = [
            {
                state: 'frozen',
                xSplit: 4,
                ySplit: 2,
            }
        ];

        await this.downloadBook(workbook, filename);
    }

    async downloadCandidates(candidates, headers, filename, isFacilitator) {
        const workbook = this.createBook();
        const sheet = workbook.addWorksheet(filename);
        sheet
            .addRow(['CANDIDATES REPORT'])
            .font = {
                family: 2,
                name: 'Arial',
                size: 12,
                bold: true,
        };

        const rowHeaders = [];
        for (let i = 0; i < headers.length; i++) {
            rowHeaders.push(headers[i].title.toUpperCase());

            if (headers[i].isStageHeader) {
                rowHeaders.push('#');
            }
        }

        const stageHeadersCells = [];
        rowHeaders.forEach((header, i) => {
            if (header === '#') {
                stageHeadersCells.push({leftIndex: i - 1, rightIndex: i});
                rowHeaders[i] = '';
            }
        });

        stageHeadersCells.pop();

        const reducedStageIndexes = stageHeadersCells.reduce((acc, cur) => [...acc, cur.leftIndex, cur.rightIndex], []);
        const nonStageHeadersCells = [];
        rowHeaders.forEach((header, index) => {
            if (!reducedStageIndexes.includes(index)) {
                nonStageHeadersCells.push(index);
            }
        });

        nonStageHeadersCells.splice((!isFacilitator ? 10 : 9), 1);

        const lastStageSubHeaderIndex = !isFacilitator ? 25 : 24;

        sheet.addRow([...rowHeaders.slice(0, lastStageSubHeaderIndex), ...rowHeaders.slice(lastStageSubHeaderIndex + 1)]);

        const leftMarginArray = ['', '', '', '', '', '', '', '', ''];
        if (!isFacilitator) leftMarginArray.push('');

        const stageSubHeaders = stageHeadersCells.reduce(
            (subStageHeaders) => [...subStageHeaders, 'COMPLETED', 'STATUS'],
            leftMarginArray,
        );

        stageSubHeaders[stageSubHeaders.length - 1] = 'OFFER STATUS';

        sheet.addRow([...stageSubHeaders, 'ACTUAL START']);
        // merge horizontal stage headers cells
        stageHeadersCells.forEach(mergeIndexes => {
            sheet.mergeCells(2, mergeIndexes.leftIndex + 1, 2, mergeIndexes.rightIndex + 1)
        });

        // merge vertical non stage headers cells
        nonStageHeadersCells.forEach((cellIndex) => {
            sheet.mergeCells( 2,  cellIndex + 1,  3, cellIndex + 1);
        });

        const headersRows = [sheet.getRow(2), sheet.getRow(3)];

        headersRows.forEach(row => {
            row.eachCell(cell => {
                cell.style = HR_BLACK_HEADERS_STYLES.style;
                cell.fill = HR_BLACK_HEADERS_STYLES.fill;
                cell.font = HR_BLACK_HEADERS_STYLES.font;
            });
        });

        sheet.columns = headers.reduce((columnWidths, h) => (
            [
                ...columnWidths,
                ...(h.isStageHeader ? [{width: h.exportWidth}, {width: h.exportWidth}] : [{width: h.exportWidth}])
            ]
        ), []);

        candidates.forEach(candidate => {

            const row = [];
            headers.forEach(header => {

                const cellValue = header.isStageHeader ?
                    [
                        candidate.candidate_trackings[header.index].date,
                        candidate.candidate_trackings[header.index].status
                    ]:
                    [candidate[header.key]];

                row.push(...cellValue);
            });
            // Avoid to add an extra column (status) for start stage
            row.splice((isFacilitator ? 24 : 25), 1);
            const addedRow = sheet.addRow(row);

            const totalHeadersCount = isFacilitator ? 27 : 26;
            for (let i = 1; i <= totalHeadersCount; i++) {
                if(i < isFacilitator ? 7 : 6){
                    addedRow.getCell(i).style = {alignment: { wrapText: true }};
                }
                addedRow.getCell(i).font = {
                    color: {argb: '00000000'},
                    family: 2,
                    name: 'Arial',
                    size: 10,
                    bold: false
                };            }
        });

        sheet.views = [
            {
                state: 'frozen',
                xSplit: isFacilitator ? 7 : 6,
                ySplit: 3,
            }
        ];

        await this.downloadBook(workbook, filename);
    }

    async downloadStaffingDasboard(reportData, filename, year) {
        const workbook = this.createBook();
        const sheet = workbook.addWorksheet(filename);

        const sectionKeys = {
            headcount_turnover: {
                annual: [
                    { key: 'beginning_delta', title: 'Beginning Sales and Mktg Staff'},
                    { key: 'terms_in_month', title: 'Terms in Month - Sales and Mktg Staff'},
                    { key: 'hires_in_month', title: 'Hires in Month - Sales and Mktg Staff'},
                    { key: 'headcount', title: 'Sales and Mktg Headct - End of Month'},
                    { key: 'total', title: 'Total Budgeted Sales & Mktg Headcount'}
                ],
                turnover_by_type: [
                    { key: 'regrettable', title: 'Regrettable - Voluntary'},
                    { key: 'non-regrettable', title: 'Non-Regrettable - Voluntary'},
                    { key: 'voluntary', title: 'Voluntary'},
                    { key: 'involuntary', title: 'Involuntary'},
                    { key: 'total', title: 'Total'}
                ],
                turnover_by_reason: [
                    { key: 'comp_ben', title: 'Better Opportunity - Comp & Ben'},
                    { key: 'job_duties', title: 'Better Opportunity - Job Duties/Workload'},
                    { key: 'performance', title: 'Performance'},
                    { key: 'personal', title: 'Personal / Other'},
                    { key: 'rif', title: 'RIF'},
                    { key: 'total', title: 'Total Terminations'}
                ]
            },
            candidate_conversion: [
                { key: 'referral', title: 'Referral'},
                { key: 'job_board', title: 'Job Board'},
                { key: 'agency', title: 'Agency'},
                { key: 'internal', title: 'Internal'},
                { key: 'total', title: 'Total'}
            ]
        }

        // sections rows
        staffingDashboardHeadcount(sheet, reportData.data.headcount_turnover, reportData.headers, sectionKeys.headcount_turnover);
        staffingDashboardCandidatesConversion(sheet, reportData.data.candidates_conversion, reportData.headers, sectionKeys.candidate_conversion);

        const columnWidths = [];
        for (let i = 0; i < 16; i++) {
            if(i == 0){
                columnWidths.push({width: 45});
            }else{
                columnWidths.push({width: 14});
            }

        }
        sheet.columns = columnWidths;
        this.downloadBook(workbook, filename);
    }

    // Talent Tracking
    async downloadCandidates(candidates, candidateHeaders, filename) {
        const STATUS_TYPES = ['Available', 'Interview Scheduled', 'Hired'];
        const workbook = this.createBook();
        const sheet = workbook.addWorksheet(filename);

        var headerColumns = [];
        candidateHeaders.map(header => {
            headerColumns.push({
                header: header.title,
                key: header.key,
                width: header.exportWidth,
            })
        });

        var columnsKey = [];

        for (let columnIndex = 0; columnIndex < headerColumns.length; columnIndex++) {
            var column = headerColumns[columnIndex];
            columnsKey.push({
                key:column.key,
                width: column.width
            });
            sheet.getRow(1).getCell(columnIndex+1).value = column.header;
            sheet.getRow(1).getCell(columnIndex+1).style = HR_BLACK_HEADERS_STYLES.style;
            sheet.getRow(1).getCell(columnIndex+1).width = column.width;
            sheet.getRow(1).getCell(columnIndex+1).fill = HR_BLACK_HEADERS_STYLES.fill;
            sheet.getRow(1).getCell(columnIndex+1).font = HR_BLACK_HEADERS_STYLES.font;
        }

        sheet.columns = columnsKey;
        sheet.font = {
            family: 2,
            name: 'Arial',
            size: 10
        };

        candidates.forEach(candidate => {

            const row = [];
            candidateHeaders.forEach(header => {
                const cellValue =
                    header.key !== 'status' ? formatValue(header.key === 'phone_number' ? 9 : 7, candidate[header.key]) : STATUS_TYPES[candidate.status];
                row.push(cellValue);
            });

            const addedRow = sheet.addRow(row);
            addedRow.font = {
                color: {argb: '00000000'},
                family: 2,
                name: 'Arial',
                size: 10,
                bold: false
            };
        });

        sheet.views = [
            {
                state: 'frozen',
                xSplit: 4,
                ySplit: 1,
            }
        ];

        await this.downloadBook(workbook, filename);
    }

    async exportISRActivityByEmployee(data, username, filename) {
        const { headers, teams } = data;
        const workbook = this.createBook(username);
        const sheet = workbook.addWorksheet(filename);
        sheet.views = [{ state: 'frozen', xSplit: 2, ySplit: 1, topLeftCell: 'C2'}];

        const uppercaseHeaders = headers.map(header => header.toUpperCase());

        var headerColumns = [
            { header: 'METRIC', key: 'metric', width: 35,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'left' },
                    font: { family: 2, name: 'Arial', bold: true, size: 10 },
                }
            },
            { header: 'TYPE', key: 'type', width: 12,
                style: {
                    alignment: {vertical: 'middle', horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 8 },
                }
            },
        ];

        uppercaseHeaders.forEach(header => {
            headerColumns.push({
                header: header,
                key: header,
                width: 14,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'center' }
                }
            });
        });

        headerColumns.push({
            header: 'COMMENTS',
            key: 'comments',
            width: 50,
            style: {
                alignment: { vertical: 'middle', horizontal: 'left' },
                font: { family: 2, name: 'Arial', size: 10 }
            }
        });

        for (let columnIndex = 0; columnIndex < headerColumns.length; columnIndex++) {
            var column = headerColumns[columnIndex];
            sheet.getRow(1).getCell(columnIndex+1).value = column.header;
            sheet.getRow(1).getCell(columnIndex+1).style = {
                alignment: { vertical: 'middle', horizontal: 'center' },
                font: {
                    color: {argb: '00FFFFFF'},
                    family: 2,
                    name: 'Arial',
                    bold: true
                },
                fill: {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor: {argb: '001f53a1'},
                    bgColor: {argb: '001f53a1'}
                }
            };
            sheet.columns[columnIndex].width = column.width;
        }

        sheet.getRow(1).height = 22;

        teams.forEach((team) => {
            let teamRowValues = [];
            teamRowValues[0] = team.title;
            let teamRow = sheet.addRow(teamRowValues);

            teamRow.height = 22;

            for (let i = 1; i <= headerColumns.length; i++) {
                teamRow.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: {argb: '00404040'},
                    bgColor: {argb: '00404040'}
                };
                teamRow.getCell(i).font = {
                    color: {argb: '00f8f9fa'},
                    family: 2,
                    name: 'Arial',
                    bold: true,
                    size: 12
                };
            }

            if (team.employees && team.employees.length > 0) {
                team.employees.forEach(employee => {
                    if (employee.metrics && employee.metrics.length > 0) {
                        let employeeRowValues = [];
                        employeeRowValues[0] = employee.name + (employee.start_date_formatted ? ' - ' + employee.start_date_formatted : '');
                        let employeeHeaderRow = sheet.addRow(employeeRowValues);

                        for (let i = 1; i <= headerColumns.length; i++) {
                            employeeHeaderRow.getCell(i).fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: {argb: '00000000'},
                                bgColor: {argb: '00000000'}
                            };
                            employeeHeaderRow.getCell(i).font = {
                                color: {argb: '00FFFFFF'},
                                family: 2,
                                name: 'Arial',
                                bold: true
                            };
                        }

                        employee.metrics.forEach(metric => {
                            let rowActualValues = [];
                            let rowBudgetValues = [];

                            rowActualValues[0] = metric.title;
                            rowBudgetValues[0] = '';

                            rowActualValues[1] = 'ACTUAL';
                            rowBudgetValues[1] = 'BUDGET';

                            headers.forEach((header, headerIndex) => {
                                const parts = header.split('/');
                                const monthName = parts[0];
                                const year = parts[1];
                                const monthIndex = new Date(Date.parse(monthName + " 1, 2000")).getMonth() + 1;
                                const dateKey = `${year}-${String(monthIndex).padStart(2, '0')}-01`;

                                const valueIndex = headerIndex + 2;

                                if (metric.data && metric.data[dateKey]) {
                                    if (metric.format === 2) {
                                        rowActualValues[valueIndex] = parseFloat(metric.data[dateKey].actual * 1) / 100;
                                        rowBudgetValues[valueIndex] = parseFloat(metric.data[dateKey].budget * 1) / 100;
                                    } else {
                                        rowActualValues[valueIndex] = metric.data[dateKey].actual * 1;
                                        rowBudgetValues[valueIndex] = metric.data[dateKey].budget * 1;
                                    }
                                } else {
                                    rowActualValues[valueIndex] = 0;
                                    rowBudgetValues[valueIndex] = 0;
                                }
                            });

                            let rowActual = sheet.addRow(rowActualValues);
                            let rowBudget = null;

                            if (metric.show_budget) {
                                rowBudget = sheet.addRow(rowBudgetValues);
                            }

                            rowActual.getCell(1).style = {
                                alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
                                font: { family: 2, name: 'Arial', size: 11, bold: true }
                            };

                            rowActual.getCell(2).style = {
                                alignment: { vertical: 'middle', horizontal: 'center'},
                                font: { family: 2, name: 'Arial', size: 8, italic: true }
                            };

                            if (metric.show_budget && rowBudget) {
                                sheet.mergeCells(rowActual.getCell(1).address + ':' + rowBudget.getCell(1).address);

                                rowBudget.getCell(2).style = {
                                    alignment: { vertical: 'middle', horizontal: 'center'},
                                    font: { family: 2, name: 'Arial', size: 8, italic: true }
                                };

                                // Merge Comments column when there's a budget row
                                const commentsColumnIndex = headers.length + 3; // +3 because we have METRIC, TYPE, and then the headers
                                sheet.mergeCells(rowActual.getCell(commentsColumnIndex).address + ':' + rowBudget.getCell(commentsColumnIndex).address);
                            }

                            headers.forEach((header, headerIndex) => {
                                const cellIndex = headerIndex + 3;

                                const parts = header.split('/');
                                const monthName = parts[0];
                                const year = parts[1];
                                const monthIndex = new Date(Date.parse(monthName + " 1, 2000")).getMonth() + 1;
                                const dateKey = `${year}-${String(monthIndex).padStart(2, '0')}-01`;

                                if (metric.data && metric.data[dateKey]) {
                                    const cellData = metric.data[dateKey];
                                    let conditionalBgColor = "FFFFFF";

                                    const today = new Date();
                                    let headerDate = new Date(header);

                                    if (headerDate.getFullYear() === today.getFullYear() && headerDate.getMonth() === today.getMonth()) {
                                        conditionalBgColor = "FFFFFF";
                                    } else {
                                        if (headerDate.getTime() <= today.getTime()) {
                                            if (cellData.actual !== undefined && cellData.budget !== undefined) {
                                                if (cellData.actual >= cellData.budget) {
                                                    conditionalBgColor = "c6efce";
                                                } else {
                                                    conditionalBgColor = "ffc7ce";
                                                }
                                            }
                                        }
                                    }


                                    rowActual.getCell(cellIndex).font = {
                                        family: 2,
                                        name: 'Arial',
                                        size: 10,
                                        color: {argb: "00000000"}
                                    };

                                    rowActual.getCell(cellIndex).fill = {
                                        type: 'pattern',
                                        pattern: 'solid',
                                        fgColor: {argb: "00" + conditionalBgColor},
                                        bgColor: {argb: "00" + conditionalBgColor}
                                    };

                                    if (metric.show_budget && rowBudget) {
                                        rowBudget.getCell(cellIndex).font = {
                                            family: 2,
                                            name: 'Arial',
                                            size: 10,
                                            color: {argb: "00000000"}
                                        };

                                        rowBudget.getCell(cellIndex).fill = {
                                            type: 'pattern',
                                            pattern: 'solid',
                                            fgColor: {argb: "00FFFFFF"},
                                            bgColor: {argb: "00FFFFFF"}
                                        };
                                    }
                                } else {
                                    rowActual.getCell(cellIndex).font = {
                                        family: 2,
                                        name: 'Arial',
                                        size: 10,
                                        color: {argb: "00000000"}
                                    };

                                    rowActual.getCell(cellIndex).fill = {
                                        type: 'pattern',
                                        pattern: 'solid',
                                        fgColor: {argb: "00FFFFFF"},
                                        bgColor: {argb: "00FFFFFF"}
                                    };

                                    if (metric.show_budget && rowBudget) {
                                        rowBudget.getCell(cellIndex).font = {
                                            family: 2,
                                            name: 'Arial',
                                            size: 10,
                                            color: {argb: "00000000"}
                                        };

                                        rowBudget.getCell(cellIndex).fill = {
                                            type: 'pattern',
                                            pattern: 'solid',
                                            fgColor: {argb: "00FFFFFF"},
                                            bgColor: {argb: "00FFFFFF"}
                                        };
                                    }
                                }
                            });

                            let numFmt = '';
                            switch (metric.format) {
                                case 1:
                                    numFmt = '"$"#,##0;[Red]\-"$"#,##0';
                                    break;
                                case 2:
                                    numFmt = '#,##0.0%';
                                    break;
                                case 0:
                                case 3:
                                    numFmt = '#,##0.0';
                                    break;
                                case 4:
                                    numFmt = '#,##0.0x';
                                    break;
                                case 5:
                                    numFmt = '#,##0.0" bps"';
                                    break;
                                default:
                                    break;
                            }

                            rowActual.numFmt = numFmt;
                            if (metric.show_budget && rowBudget) {
                                rowBudget.numFmt = numFmt;
                                rowBudget.border = {
                                    bottom: {style: 'thin', color: {argb: '00cccccc'}}
                                };
                            } else {
                                rowActual.border = {
                                    bottom: {style: 'thin', color: {argb: '00cccccc'}}
                                };
                            }

                            // Style the Comments column
                            const commentsColumnIndex = headers.length + 3; // +3 because we have METRIC, TYPE, and then the headers
                            rowActual.getCell(commentsColumnIndex).style = {
                                alignment: { vertical: 'middle', horizontal: 'left' },
                                font: { family: 2, name: 'Arial', size: 10, color: {argb: '00000000'} },
                                fill: {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: {argb: '00FFFFFF'},
                                    bgColor: {argb: '00FFFFFF'}
                                }
                            };
                            rowActual.getCell(commentsColumnIndex).border = {
                                bottom: {style: 'thin', color: {argb: '00cccccc'}},
                                top: {style: 'thin', color: {argb: '00cccccc'}}
                            };

                            if (metric.show_budget && rowBudget) {
                                rowBudget.getCell(commentsColumnIndex).style = {
                                    alignment: { vertical: 'middle', horizontal: 'left' },
                                    font: { family: 2, name: 'Arial', size: 10, color: {argb: '00000000'} },
                                    fill: {
                                        type: 'pattern',
                                        pattern: 'solid',
                                        fgColor: {argb: '00FFFFFF'},
                                        bgColor: {argb: '00FFFFFF'}
                                    }
                                };
                                rowBudget.getCell(commentsColumnIndex).border = {
                                    bottom: {style: 'thin', color: {argb: '00cccccc'}},
                                    top: {style: 'thin', color: {argb: '00cccccc'}}
                                };
                            }
                        });
                    }
                });
            } else {
                let dummyRowValues = [];
                let dummyRow = sheet.addRow(dummyRowValues);

                for (let i = 1; i <= headerColumns.length; i++) {
                    dummyRow.getCell(i).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {argb: '00FFFFFF'},
                        bgColor: {argb: '00FFFFFF'}
                    };
                }
            }

            let emptyRowValues = [];
            let emptyRow = sheet.addRow(emptyRowValues);
            emptyRow.height = 15;
        });

        sheet.font = {
            family: 2,
            name: 'Arial',
            size: 10
        };

        await this.downloadBook(workbook, filename);
    }

    async exportISRActivityByMetric(data, username, filename, activityYTDValues = {}) {
        const { headers, teams } = data;
        const workbook = this.createBook(username);
        const sheet = workbook.addWorksheet(filename);
        sheet.views = [{ state: 'frozen', xSplit: 2, ySplit: 1, topLeftCell: 'C2' }];

        const uppercaseHeaders = headers.map(header => header.toUpperCase());
        const START_DATE_STYLE = {
            alignment: { vertical: 'middle', horizontal: 'center' },
            font: { family: 2, name: 'Arial', size: 10 }
        };
        const headerColumns = [
            { header: 'METRIC', key: 'metric', width: 35 },
            { header: 'START DATE', key: 'start_date', width: 15 },
            { header: 'TYPE', key: 'type', width: 12 },
            { header: 'YTD', key: 'ytd', width: 12 },
            ...uppercaseHeaders.map(header => ({
                header,
                key: header,
                width: 14,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'center' }
                }
            }))
        ];

        headerColumns.push({
            header: 'COMMENTS',
            key: 'comments',
            width: 50,
            style: {
                alignment: { vertical: 'middle', horizontal: 'left' },
                font: { family: 2, name: 'Arial', size: 10 }
            }
        });

        for (let i = 0; i < headerColumns.length; i++) {
            const col = headerColumns[i];
            const cell = sheet.getRow(1).getCell(i + 1);
            cell.value = col.header;
            cell.style = {
                alignment: { vertical: 'middle', horizontal: 'center' },
                font: { color: { argb: '00FFFFFF' }, family: 2, name: 'Arial', bold: true },
                fill: {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '001f53a1' },
                    bgColor: { argb: '001f53a1' }
                }
            };
            sheet.columns[i].width = col.width;
        }

        sheet.getRow(1).height = 22;

        for (const team of teams) {
            const teamRow = sheet.addRow([team.title]);
            teamRow.height = 22;
            for (let i = 1; i <= headerColumns.length; i++) {
                teamRow.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '00404040' },
                    bgColor: { argb: '00404040' }
                };
                teamRow.getCell(i).font = {
                    color: { argb: '00f8f9fa' },
                    family: 2,
                    name: 'Arial',
                    bold: true,
                    size: 12
                };
            }

            const metricMap = new Map();

            for (const emp of team.employees || []) {
                for (const metric of emp.metrics || []) {
                    if (!metricMap.has(metric.title)) {
                        metricMap.set(metric.title, []);
                    }
                    metricMap.get(metric.title).push({
                        ...metric,
                        employee: emp.name,
                        employee_id: emp.id,
                        start_date_formatted: emp.start_date_formatted
                    });
                }
            }

            for (const [metricTitle, entries] of metricMap.entries()) {
                const metricRow = sheet.addRow([metricTitle]);
                for (let i = 1; i <= headerColumns.length; i++) {
                    metricRow.getCell(i).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: '00000000' },
                        bgColor: { argb: '00000000' }
                    };
                    metricRow.getCell(i).font = {
                        color: { argb: '00FFFFFF' },
                        family: 2,
                        name: 'Arial',
                        bold: true
                    };
                }

                const totals = {};
                const targets = {};

                for (const entry of entries) {
                    const { employee, employee_id, start_date_formatted, data, show_budget, format } = entry;
                    const metricId = entry.id;

                    const actualRowValues = [employee, start_date_formatted || '', 'ACTUAL', activityYTDValues[employee_id][metricId].actual];
                    const budgetRowValues = ['', '', 'BUDGET', activityYTDValues[employee_id][metricId].budget];

                    headers.forEach(header => {
                        const [monthName, year] = header.split('/');
                        const monthIndex = new Date(Date.parse(monthName + ' 1, 2000')).getMonth() + 1;
                        const dateKey = `${year}-${String(monthIndex).padStart(2, '0')}-01`;
                        const cellData = (data && data[dateKey]) ? data[dateKey] : {};
                        const actual = (cellData && cellData.actual != null) ? cellData.actual : 0;
                        const budget = (cellData && cellData.budget != null) ? cellData.budget : 0;

                        if (!totals[dateKey]) totals[dateKey] = 0;
                        totals[dateKey] += actual;

                        if (!targets[dateKey]) targets[dateKey] = 0;
                        targets[dateKey] += budget;

                        const valActual = (format === 2) ? actual / 100 : actual;
                        const valBudget = (format === 2) ? budget / 100 : budget;

                        actualRowValues.push(valActual);
                        budgetRowValues.push(valBudget);
                    });

                    const rowActual = sheet.addRow(actualRowValues);
                    let rowBudget = null;
                    if (show_budget) rowBudget = sheet.addRow(budgetRowValues);

                    rowActual.getCell(1).style = {
                        alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
                        font: { family: 2, name: 'Arial', size: 11, bold: true }
                    };
                    rowActual.getCell(3).style = {
                        alignment: { vertical: 'middle', horizontal: 'center' },
                        font: { family: 2, name: 'Arial', size: 8, italic: true }
                    };

                    rowActual.getCell(2).style = START_DATE_STYLE;

                    if (show_budget && rowBudget) {
                        sheet.mergeCells(`${rowActual.getCell(1).address}:${rowBudget.getCell(1).address}`);
                        sheet.mergeCells(`${rowActual.getCell(2).address}:${rowBudget.getCell(2).address}`);
                        rowBudget.getCell(3).style = {
                            alignment: { vertical: 'middle', horizontal: 'center' },
                            font: { family: 2, name: 'Arial', size: 8, italic: true }
                        };
                        rowBudget.getCell(2).style = START_DATE_STYLE;

                        // Merge Comments column when there's a budget row
                        const commentsColumnIndex = headers.length + 5 // +5 because we have METRIC, START DATE, TYPE, YTD and then the headers
                        sheet.mergeCells(rowActual.getCell(commentsColumnIndex).address + ':' + rowBudget.getCell(commentsColumnIndex).address);
                    }

                    // Handle YTD column (fixed column 4)
                    const ytdColIndex = 4;
                    const ytdActual = activityYTDValues[employee_id][metricId].actual;
                    const ytdBudget = activityYTDValues[employee_id][metricId].budget;
                    
                    let ytdColor = 'FFFFFF';
                    if (ytdActual !== undefined && ytdBudget !== undefined) {
                        ytdColor = ytdActual >= ytdBudget ? 'c6efce' : 'ffc7ce';
                    }

                    rowActual.getCell(ytdColIndex).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: '00' + ytdColor },
                        bgColor: { argb: '00' + ytdColor }
                    };
                    rowActual.getCell(ytdColIndex).font = {
                        family: 2,
                        name: 'Arial',
                        size: 10,
                        color: { argb: '00000000' }
                    };

                    if (show_budget && rowBudget) {
                        rowBudget.getCell(ytdColIndex).fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: '00FFFFFF' },
                            bgColor: { argb: '00FFFFFF' }
                        };
                        rowBudget.getCell(ytdColIndex).font = {
                            family: 2,
                            name: 'Arial',
                            size: 10,
                            color: { argb: '00000000' }
                        };
                    }

                    // Handle dynamic headers (columns 5+)
                    for (let h = 0; h < headers.length; h++) {
                        const colIndex = h + 5;

                        const [monthName, year] = headers[h].split('/');
                        const monthIndex = new Date(Date.parse(monthName + ' 1, 2000')).getMonth() + 1;
                        const dateKey = `${year}-${String(monthIndex).padStart(2, '0')}-01`;

                        const cellData = (data && data[dateKey]) ? data[dateKey] : {};
                        const actual = (cellData && cellData.actual != null) ? cellData.actual : 0;
                        const budget = (cellData && cellData.budget != null) ? cellData.budget : 0;

                        let color = 'FFFFFF';
                        if (actual !== undefined && budget !== undefined) {
                            color = actual >= budget ? 'c6efce' : 'ffc7ce';
                        }

                        rowActual.getCell(colIndex).fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: '00' + color },
                            bgColor: { argb: '00' + color }
                        };
                        rowActual.getCell(colIndex).font = {
                            family: 2,
                            name: 'Arial',
                            size: 10,
                            color: { argb: '00000000' }
                        };

                        if (show_budget && rowBudget) {
                            rowBudget.getCell(colIndex).fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: '00FFFFFF' },
                                bgColor: { argb: '00FFFFFF' }
                            };
                            rowBudget.getCell(colIndex).font = {
                                family: 2,
                                name: 'Arial',
                                size: 10,
                                color: { argb: '00000000' }
                            };
                        }
                    }

                    let numFmt = '';
                    switch (format) {
                        case 1: numFmt = '"$"#,##0;[Red]\-"$"#,##0'; break;
                        case 2: numFmt = '#,##0.0%'; break;
                        case 3:
                        case 0: numFmt = '#,##0.0'; break;
                        case 4: numFmt = '#,##0.0x'; break;
                        case 5: numFmt = '#,##0.0" bps"'; break;
                    }

                    rowActual.numFmt = numFmt;
                    if (show_budget && rowBudget) {
                        rowBudget.numFmt = numFmt;
                        rowBudget.border = {
                            bottom: { style: 'thin', color: { argb: '00cccccc' } },
                            top: { style: 'thin', color: { argb: '00cccccc' } }
                        };
                    } else {
                        rowActual.border = {
                            bottom: { style: 'thin', color: { argb: '00cccccc' } },
                            top: { style: 'thin', color: { argb: '00cccccc' } }
                        };
                    }

                    // Style the Comments column
                    const commentsColumnIndex = headers.length + 5; // +5 because we have METRIC, START DATE, TYPE, YTD and then the headers
                    rowActual.getCell(commentsColumnIndex).style = {
                        alignment: { vertical: 'middle', horizontal: 'left' },
                        font: { family: 2, name: 'Arial', size: 10, color: {argb: '00000000'} },
                        fill: {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: '00FFFFFF'},
                            bgColor: {argb: '00FFFFFF'}
                        }
                    };
                    rowActual.getCell(commentsColumnIndex).border = {
                        bottom: {style: 'thin', color: {argb: '00cccccc'}},
                        top: {style: 'thin', color: {argb: '00cccccc'}}
                    };

                    if (show_budget && rowBudget) {
                        rowBudget.getCell(commentsColumnIndex).style = {
                            alignment: { vertical: 'middle', horizontal: 'left' },
                            font: { family: 2, name: 'Arial', size: 10, color: {argb: '00000000'} },
                            fill: {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: {argb: '00FFFFFF'},
                                bgColor: {argb: '00FFFFFF'}
                            }
                        };
                        rowBudget.getCell(commentsColumnIndex).border = {
                            bottom: {style: 'thin', color: {argb: '00cccccc'}},
                            top: {style: 'thin', color: {argb: '00cccccc'}}
                        };
                    }
                }

                // Calculate YTD totals
                let ytdTotal = 0;
                let ytdTarget = 0;
                for (const entry of entries) {
                    const { employee_id } = entry;
                    const metricId = entry.id;
                    ytdTotal += activityYTDValues[employee_id][metricId].actual || 0;
                    ytdTarget += activityYTDValues[employee_id][metricId].budget || 0;
                }

                const totalRow = ['Total', '', '', ytdTotal];
                const targetRow = ['Target', '', '', ytdTarget];

                headers.forEach(header => {
                    const [monthName, year] = header.split('/');
                    const monthIndex = new Date(Date.parse(monthName + ' 1, 2000')).getMonth() + 1;
                    const dateKey = `${year}-${String(monthIndex).padStart(2, '0')}-01`;

                    totalRow.push(totals[dateKey] || 0);
                    targetRow.push(targets[dateKey] || 0);
                });

                const rTotal = sheet.addRow(totalRow);
                const rTarget = sheet.addRow(targetRow);
                
                // Style YTD column in totals (column 4)
                const ytdTotalColor = ytdTotal >= ytdTarget ? 'c6efce' : 'ffc7ce';
                rTotal.getCell(4).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '00' + ytdTotalColor }
                };
                rTotal.getCell(4).font = {
                    color: { argb: '00000000' },
                    name: 'Arial',
                    size: 10
                };
                rTarget.getCell(4).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '00FFFFFF' }
                };
                rTarget.getCell(4).font = {
                    color: { argb: '00000000' },
                    name: 'Arial',
                    size: 10
                };

                // Style dynamic columns (columns 5+)
                for (let i = 5; i <= totalRow.length ; i++) {
                    const totalValue = totalRow[i - 1] || 0;
                    const targetValue = targetRow[i - 1] || 0;
                    const color = totalValue >= targetValue ? 'c6efce' : 'ffc7ce';

                    rTotal.getCell(i).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: '00' + color }
                    };
                    rTotal.getCell(i).font = {
                        color: { argb: '00000000' },
                        name: 'Arial',
                        size: 10
                    };
                    rTarget.getCell(i).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: '00FFFFFF' }
                    };
                    rTarget.getCell(i).font = {
                        color: { argb: '00000000' },
                        name: 'Arial',
                        size: 10
                    };
                }

                // Merge Comments column for totals
                const commentsColumnIndex = headers.length + 5; // +5 because we have METRIC, START DATE, TYPE, YTD and then the headers
                sheet.mergeCells(rTotal.getCell(commentsColumnIndex).address + ':' + rTarget.getCell(commentsColumnIndex).address);

                const emptyRow = sheet.addRow([]);
                emptyRow.height = 15;
            }
        }

        sheet.font = {
            family: 2,
            name: 'Arial',
            size: 10
        };

        await this.downloadBook(workbook, filename);
    }

}

const staffingDashboardHeadcount = (sheet, data, generalHeaders, annualHeaders) => {
    const dates = generalHeaders.dates.map(month => month.toUpperCase());
    const titleRow = sheet.addRow(['Headcount and TurnOver'].concat(dates));
    for (let index = 1; index <= dates.length + 1; index++){
        titleRow.getCell(index).style = STAFFING_DASHBOARD_HEADER;
    }

    const sectionTitles = {
        annual: 'Annual Sales & Marketing Headcount Budgeted vs Forecast & Hiring Cadence',
        turnover_by_type: 'Turnover by Type',
        turnover_by_reason: 'Turnover by Reason'
    };

    Object.keys(annualHeaders).map(section => {
        const sectionTitle = sheet.addRow([sectionTitles[section]]);
        sheet.mergeCells(`${sectionTitle.getCell(1).address}:${sectionTitle.getCell(14).address}`);
        sectionTitle.getCell(1).style = ARIAL_10_BOLD_LEFT;

        annualHeaders[section].map(sectionRow => {
            let rowData = [sectionRow.title];
            generalHeaders.dates.map(date => {
                rowData.push(data[section][sectionRow.key][date]);
            })
            const row = sheet.addRow(rowData);

            if (sectionRow.key.includes('total')) {
                for (let index = 1; index <= 14; index++) {
                    if (index == 1) {
                        row.getCell(index).style = ARIAL_10_BORDER;
                    } else {
                        row.getCell(index).style = {
                            alignment: { vertical: 'middle', horizontal: 'center'},
                            font: { bold:true, ... ARIAL_10 },
                            border: {top: {style: 'thin'}}
                        };
                    }
                }
            } else {
                row.alignment = ARIAL_10_CENTER.alignment;
                row.font = ARIAL_10_CENTER.font;
                row.getCell(1).style = {
                    alignment: { vertical: 'middle', horizontal: 'left'},
                    font: ARIAL_10,
                };
            }
        });

        const emptyRow = sheet.addRow(['']);
        sheet.mergeCells(`${emptyRow.getCell(1).address}:${emptyRow.getCell(14).address}`);
    });
};

const staffingDashboardCandidatesConversion = (sheet, data, generalHeaders, candidateConversion) => {
    const dates = generalHeaders.periods.map(period => period.toUpperCase());
    let titleRowData = ['Candidates Conversion by Source'];
    dates.map(period => {
        titleRowData.push(period, '', '', '', '',);
    });
    const titleRow = sheet.addRow(titleRowData);

    sheet.mergeCells(`${titleRow.getCell(2).address}:${titleRow.getCell(6).address}`);
    sheet.mergeCells(`${titleRow.getCell(7).address}:${titleRow.getCell(11).address}`);
    sheet.mergeCells(`${titleRow.getCell(12).address}:${titleRow.getCell(16).address}`);

    for (let index = 1; index <= 16; index++) {
        titleRow.getCell(index).style = STAFFING_DASHBOARD_HEADER;
    }

    [2,7,12].map(cellIndex => {
        titleRow.getCell(cellIndex).style = {
            alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
            fill: {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '00dee2e6'},
                bgColor: {argb: '00dee2e6'}
            },
            font: {
                color: {argb: '00000000'},
                family: 2,
                size: 10,
                name: 'Arial',
                bold: true
            },
        };
    });

    const columns = generalHeaders.candidates_conversion;

    const subTitleData = [''];
    for (let index = 0; index < dates.length; index++) {
        columns.map(column => {
            subTitleData.push(column.title);
        })
    }

    const subtitleRow = sheet.addRow(subTitleData);
    subtitleRow.height = 30;
    for (let index = 2; index <= 16; index++) {
        subtitleRow.getCell(index).style = {
            alignment: { vertical: 'middle', horizontal: 'center'},
            font: { underline: true, ... ARIAL_10 }
        };
    }

    candidateConversion.map(candidateRow => {
        let rowData = [candidateRow.title];
        generalHeaders.periods.map(period => {
            columns.map(column => {
                rowData.push(data[candidateRow.key][period][column.key]);
            });
        })

        const row = sheet.addRow(rowData);

        if (candidateRow.key.includes('total')) {
            for (let index = 1; index <= 16; index++) {
                if (index == 1) {
                    row.getCell(index).style = ARIAL_10_BORDER;
                } else {
                    row.getCell(index).style = {
                        alignment: { vertical: 'middle', horizontal: 'center'},
                        font: { bold:true, ... ARIAL_10 },
                        border: {top: {style: 'thin'}}
                    };
                }
            }
        } else {
            row.alignment = ARIAL_10_CENTER.alignment;
            row.font = ARIAL_10_CENTER.font;
            row.getCell(1).style = {
                alignment: { vertical: 'middle', horizontal: 'left'},
                font: ARIAL_10,
            };
        }
    });

    // L3M Borders
    const periodsRow = sheet.getRow(24);
    periodsRow.getCell(2).style.border = { left: {style: 'thin', color: {argb:'FFFFFFFF'}}};
    periodsRow.getCell(7).style.border = { left: {style: 'thin', color: {argb:'FFFFFFFF'}}};
    periodsRow.getCell(11).style.border = { right: {style: 'thin', color: {argb:'FFFFFFFF'}}};

    for (let rowIndex = 25; rowIndex <= 30; rowIndex++) {
        const row = sheet.getRow(rowIndex);
        if (row.getCell(7).style.border) row.getCell(7).style.border.left = { style: 'thin' };
        else row.getCell(7).style.border = { left: {style: 'thin'} };

        if (row.getCell(11).style.border) row.getCell(11).style.border.right = { style: 'thin' };
        else row.getCell(11).style.border = { right: {style: 'thin'} };
    }
};

let ExportService = new ExportServiceClass(ENVIRONMENT.API_HOST);
export default ExportService;
